// This application's identity towards the API. Together with the account and the device it forms
// the session "family" the API uses to group a login and all of its renewals.
//
// What it buys: the API only closes sessions within the same ClientId. Signing in here therefore
// never touches a session the same user has open in ToxAccess ("TA"), and the other way around.
//
// When the header is missing the API stores the session as "unknown" rather than rejecting it:
// nothing breaks, but isolation between applications stops being guaranteed. That is why it has to
// be sent on EVERY call that opens a session, not just the login: with MFA, the session is born
// when the second factor completes.
//
// The value must match one of Session:AllowedClientIds on the API exactly.
export const SESSION_CLIENT_ID_HEADER = 'X-Client-Id';

export const SESSION_CLIENT_ID = 'TAMF';

export const sessionClientHeaders = {
  [SESSION_CLIENT_ID_HEADER]: SESSION_CLIENT_ID,
};
